import { MAP_PATH, MAP_VIEW } from "./geoData";
import { PLACES } from "./geo";

const P = (lat, lon) => [(lon - MAP_VIEW.lon0) * MAP_VIEW.s, (MAP_VIEW.lat0 - lat) * MAP_VIEW.s];

const flowPath = (a, b) => {
  const dx = b[0] - a[0], dy = b[1] - a[1];
  const len = Math.hypot(dx, dy);
  let px = dy / len, py = -dx / len;
  if (py > 0) { px = -px; py = -py; }
  const k = len * 0.22;
  return `M${a[0]},${a[1]} Q${(a[0] + b[0]) / 2 + px * k},${(a[1] + b[1]) / 2 + py * k} ${b[0]},${b[1]}`;
};

export function FlowMap({ flows, testid, delay = 0 }) {
  const it = P(PLACES.italia.lat, PLACES.italia.lon);
  return (
    <svg className="flowmap" viewBox={`0 0 ${MAP_VIEW.w} ${MAP_VIEW.h}`} data-testid={testid}>
      <path d={MAP_PATH} className="map-land" />
      {flows.map((f, i) => {
        const a = P(PLACES[f.from].lat, PLACES[f.from].lon);
        const d = flowPath(a, it);
        const w = f.value * 0.55 + 1.5;
        const del = delay + 0.3 + i * 0.25;
        return (
          <g key={f.from}>
            <path d={d} className="flow-glow" stroke={f.color} strokeWidth={w * 2.6} style={{ animationDelay: `${del}s` }} pathLength="1" />
            <path d={d} className="flow-line" stroke={f.color} strokeWidth={w} style={{ animationDelay: `${del}s` }} pathLength="1" />
            <circle r={w * 0.5 + 2} fill="#fff4e4">
              <animateMotion dur={`${2.6 + i * 0.3}s`} begin={`${del + 1.4}s`} repeatCount="indefinite" path={d} />
            </circle>
            <circle cx={a[0]} cy={a[1]} r="6" fill={f.color} />
            <text x={a[0] + (f.dx ?? 12)} y={a[1] + (f.dy ?? -14)} className="map-label" textAnchor={f.anchor ?? "start"}>
              {f.name} <tspan className="map-val">{f.value.toLocaleString("it-IT")}</tspan>
            </text>
          </g>
        );
      })}
      <circle cx={it[0]} cy={it[1]} r="9" className="map-italy" />
      <circle cx={it[0]} cy={it[1]} r="9" className="map-italy-pulse" />
    </svg>
  );
}

export function ItalyMap() {
  const pb = P(42.9, 10.5);
  const rv = P(44.4, 12.2);
  return (
    <svg className="italymap" viewBox="682 128 108 96" data-testid="italy-map">
      <path d={MAP_PATH} className="map-land italy" />
      {[[pb, "Piombino", -2], [rv, "Ravenna", 2]].map(([p, n, dx]) => (
        <g key={n}>
          <circle cx={p[0]} cy={p[1]} r="1.4" fill="#6cc5ff" />
          <circle cx={p[0]} cy={p[1]} r="1.4" className="fsru-pulse" />
          <text x={p[0] + dx * 2} y={p[1] - 2.5} className="italy-label" textAnchor={dx < 0 ? "end" : "start"}>{n}</text>
        </g>
      ))}
    </svg>
  );
}

export function LngChain() {
  return (
    <svg className="chain" viewBox="0 0 900 250" data-testid="lng-chain">
      <defs>
        <linearGradient id="warm" x1="0" x2="1">
          <stop offset="0" stopColor="#6cc5ff" />
          <stop offset="1" stopColor="#ffb347" />
        </linearGradient>
      </defs>
      <g className="ship-bob">
        <path d="M30 140 L230 140 L208 176 L54 176 Z" className="hull" />
        {[75, 130, 185].map((x) => <path key={x} d={`M${x - 24} 140 A24 24 0 0 1 ${x + 24} 140`} className="tank" />)}
      </g>
      <path d="M240 158 L370 158" className="pipe ice" />
      <g>
        <path d="M380 140 L580 140 L562 176 L398 176 Z" className="hull" />
        <rect x="410" y="104" width="120" height="36" className="fsru" />
        <path d="M430 98 q8 -16 0 -32 M470 98 q8 -16 0 -32 M510 98 q8 -16 0 -32" className="vapor" />
      </g>
      <path d="M590 158 L700 158" className="pipe warm" />
      <g className="grid-net">
        <path d="M700 158 L760 110 L840 96 M760 110 L800 160 L880 150 M700 158 L770 205 L850 214 M800 160 L840 96 M770 205 L800 160" />
        {[[700, 158], [760, 110], [840, 96], [800, 160], [880, 150], [770, 205], [850, 214]].map(([x, y]) => <circle key={x + "-" + y} cx={x} cy={y} r="7" />)}
      </g>
      <text x="130" y="214" className="chain-label">Nave metaniera · GNL −162 °C</text>
      <text x="480" y="214" className="chain-label">FSRU · rigassificazione</text>
      <text x="790" y="244" className="chain-label">Rete nazionale</text>
    </svg>
  );
}
